var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Position } from "../models/position.model";
import { Injectable } from "@angular/core";
/**
 * Created by Vasilenko on 12-Nov-16.
 */
export var PuzzleKeyboardService = (function () {
    function PuzzleKeyboardService() {
        this.vectors = [new Position(-1, 0), new Position(1, 0)];
        this.vectorsPair = {};
        this.addVector(PuzzleKeyboardService.LEFT, new Position(-1, 0));
        this.addVector(PuzzleKeyboardService.RIGHT, new Position(1, 0));
        this.addVector(PuzzleKeyboardService.UP, new Position(0, -1));
        this.addVector(PuzzleKeyboardService.DOWN, new Position(0, 1));
    }
    PuzzleKeyboardService.prototype.addVector = function (key, vector) {
        this.vectorsPair[key] = vector;
        this.vectors.push(vector);
    };
    PuzzleKeyboardService.getEventKeyCode = function (keyCode) {
        switch (keyCode) {
            case 37:
                return PuzzleKeyboardService.LEFT;
            case 38:
                return PuzzleKeyboardService.UP;
            case 39:
                return PuzzleKeyboardService.RIGHT;
            case 40:
                return PuzzleKeyboardService.DOWN;
            default:
                return null;
        }
    };
    PuzzleKeyboardService.getEventSwipeCode = function (swipe) {
        switch (swipe) {
            case "swipeleft":
                return PuzzleKeyboardService.LEFT;
            case "swipeup":
                return PuzzleKeyboardService.UP;
            case "swiperight":
                return PuzzleKeyboardService.RIGHT;
            case "swipedown":
                return PuzzleKeyboardService.DOWN;
            default:
                return null;
        }
    };
    PuzzleKeyboardService.prototype.getVectorByKey = function (key) {
        return this.vectorsPair[key];
    };
    PuzzleKeyboardService.prototype.getVectors = function () {
        return this.vectors;
    };
    PuzzleKeyboardService.UP = 'up';
    PuzzleKeyboardService.RIGHT = 'right';
    PuzzleKeyboardService.DOWN = 'down';
    PuzzleKeyboardService.LEFT = 'left';
    PuzzleKeyboardService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [])
    ], PuzzleKeyboardService);
    return PuzzleKeyboardService;
}());
//# sourceMappingURL=puzzle-keyboard.service.js.map